import { render } from "./YesNoQuestion.vue?vue&type=template&id=0a5d2b6a&scoped=true"
import script from "./YesNoQuestion.vue?vue&type=script&lang=js"
export * from "./YesNoQuestion.vue?vue&type=script&lang=js"

import "./YesNoQuestion.vue?vue&type=style&index=0&id=0a5d2b6a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5d2b6a"]])

export default __exports__